module.exports = __webpack_public_path__ + "static/media/blackInfinity.7e3becdc.svg";